const sdiClickDomains = {
  dev: import.meta.env.VITE_URL_SHORTENER_URL ?? "http://localhost:7090",
  alpha: "https://alpha.sdi.click",
  staging: "https://staging.sdi.click",
  prod: "https://sdi.click",
} as const;

type SdiClickStage = keyof typeof sdiClickDomains;

export const sdiClickDomain =
  sdiClickDomains[import.meta.env.VITE_STAGE as SdiClickStage];
